import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formContainer: {
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
    },
    grayText: {
      color: theme.gray500,
      fontSize: 16,
      padding: theme.spacing(8, 0),
    },
    grayTextAnd: {
      color: theme.gray500,
      fontSize: 16,
    },
    subtitle1: {
      color: theme.black,
      fontWeight: 400,
      fontSize: 16,
      lineHeight: theme.spacing(12),
    },
    selectInputHalfWidth: {
      maxWidth: "50%",
      flex: 0.5,
      width: "50%",
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": { marginTop: 0 },
    },
    conditionSectionEdited: {
      background: theme.gray50,
      border: `1px solid ${theme.gray200}`,
      borderLeft: "none",
      borderRight: "none",
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(6, 8),
      position: "relative",
      width: "100%",
      "& + &": { marginTop: theme.spacing(12) },
    },
    conditionSectionEditedIsLastCondition: {
      borderBottom: "none",
      borderRadius: "0 0 8px 8px",
    },
    iconAdd: {
      color: theme.primary500,
    },
    icon: {
      color: theme.gray500,
      cursor: "pointer",
      height: theme.spacing(8),
      transition: "0.2s",
      width: theme.spacing(8),
    },
    bigIcon: {
      color: theme.gray500,
      cursor: "pointer",
      margin: theme.spacing(0, 2),
    },
    errorIcon: {
      color: theme.red500,
    },
    iconBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
      width: theme.spacing(12),
      minWidth: theme.spacing(12),
      height: theme.spacing(12),
      background: theme.gray50,
      margin: theme.spacing(0, 2),
      cursor: "pointer",
    },
    box: {
      border: `1px solid ${theme.gray200}`,
      padding: theme.spacing(3, 5),
      fontSize: 14,
      borderRadius: theme.spacing(2),
      textOverflow: "ellipsis",
      overflow: "hidden",
      alignSelf: "stretch",
    },
    iconsWrapper: {
      display: "flex",
      alignItems: "center",
      marginLeft: "auto",
    },
    flexColumn: {
      display: "flex",
      width: "100%",
      flexDirection: "column",
    },
    conditionWrapper: {
      border: `1px solid ${theme.gray200}`,
      borderRadius: "8px",
    },
    singleConditionRow: {
      display: "flex",
      width: "100%",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: theme.spacing(12),
    },
    readOnlyWrapper: {
      alignItems: "start",
      display: "flex",
      margin: theme.spacing(0, 7, 0, 8),
    },
    firstReadOnlyWrapper: { marginTop: theme.spacing(12) },
    lastReadOnlyWrapper: { marginBottom: theme.spacing(12) },
    boxesWrapper: {
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(5),
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(-3),
      overflow: "hidden",
    },
    conditionHeader: {
      fontSize: 14,
      fontWeight: 500,
      marginBottom: theme.spacing(12),
    },
    conditionsHeaderContainer: {
      alignItems: "baseline",
      display: "flex",
      justifyContent: "space-between",
      margin: theme.spacing(8),
      marginBottom: 0,
    },
    buttonWrapper: {
      display: "flex",
      gap: theme.spacing(12),
      justifyContent: "flex-end",
      marginTop: theme.spacing(12),
    },
    saveConditionButton: { padding: theme.spacing(4, 11) },
    topFunctions: {
      alignItems: "center",
      background: theme.gray50,
      borderBottom: `1px solid ${theme.gray200}`,
      borderRadius: "8px 8px 0 0",
      display: "flex",
      gap: theme.spacing(8),
      justifyContent: "space-between",
      padding: theme.spacing(6),
    },
    topFunctionsHidden: {
      borderBottom: "none",
      borderRadius: "8px",
    },
    ruleHeader: {
      color: theme.gray800,
      fontSize: 14,
      fontWeight: 600,
    },
    actionWrapper: {
      alignItems: "center",
      display: "flex",
    },
    addConditionButton: {
      lineHeight: "24px",
      padding: theme.spacing(2, 8),
    },
    hidden: { display: "none" },
    iconReverted: { transform: "rotate(180deg)" },
    segmentTypeInfo: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "20px",
      color: theme.gray500,
    },
    reviewLink: {
      fontSize: 16,
    },
  }),
);
